var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsentLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.63159 42.4615V4C7.63159 1.79086 9.42245 0 11.6316 0H34.8839L43.968 8.30769V42.4615C43.968 43.9304 43.3938 45.3392 42.3716 46.3778C41.3495 47.4165 39.9631 48 38.5176 48V47.9612C37.0821 47.9612 35.7055 47.3818 34.6905 46.3504C33.6755 45.319 33.1053 43.9201 33.1053 42.4615H7.63159Z",
    fill: "#BAE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 3",
    x: 14.809,
    y: 12.5625,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 4",
    x: 14.809,
    y: 16.1484,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 5",
    x: 14.8091,
    y: 19.7422,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 6",
    x: 14.8091,
    y: 23.3281,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 7",
    x: 14.809,
    y: 26.918,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 8",
    x: 14.809,
    y: 30.5039,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 9",
    x: 14.8091,
    y: 34.5391,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape 10",
    x: 14.809,
    y: 38.5781,
    width: 21.9813,
    height: 0.897196,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.9679 8.30769H43.2061C38.6179 8.30769 34.8984 4.58821 34.8984 0L43.9679 8.30769ZM38.5262 48H7.68998C6.24676 48 4.86264 47.4165 3.84213 46.3778C2.82161 45.3392 2.24829 43.9304 2.24829 42.4615H33.1226C33.1226 43.9201 33.6919 45.319 34.7053 46.3504C35.7187 47.3818 37.0931 47.9612 38.5262 47.9612V48Z",
    fill: "#3269F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentLogo);
export default __webpack_public_path__ + "static/media/consent-logo.19fd7f6498dd6d88d0d075fc5c489fb0.svg";
export { ForwardRef as ReactComponent };